const env = process.env.NODE_ENV
// 开发环境运行命令：npm run serve
// 生产环境打包命令：npm run pro
// 测试环境打包命令：npm run build
// 网站本地开发环境：9777
// 网站本地测试环境：9888
// 本地开发、测试
// baseIP: 'http://192.168.2.15:9966/web_dev/'
// 本地正式
// baseIP: 'http://192.168.2.15:9966/web/'
// 线上测试
// baseIP: 'https://hy.spbcn.org/web_test'
// 线上正式
// baseIP: 'https://hy.spbcn.org/web'
const IP = {
  development: { // 本地开发环境
    baseIP: 'https://hy.spbcn.org/web_test',
    // baseIP: 'http://192.168.0.107:9988/web_test',
    enIP: 'https://dev.spbcn.org/erp/'
  },
  production: { // 生产环境
    baseIP: 'https://hy.spbcn.org/web',
    enIP: 'https://dev.spbcn.org/erp/'
  },
  test: { // 测试环境
    baseIP: 'https://hy.spbcn.org/web_test',
    enIP: 'https://dev.spbcn.org/erp_test/'
  }
}
export default IP[env]
